// Only explicit, server-issued keys join diagnoses. Never infer an object from its URL/bbox.
export function groupCropDiagnoses(items) {
  const groups = new Map();
  const ordered = [];
  items.forEach((item) => {
    if (!item.cropObjectKey) {
      ordered.push([item]);
      return;
    }
    if (!groups.has(item.cropObjectKey)) {
      const group = [];
      groups.set(item.cropObjectKey, group);
      ordered.push(group);
    }
    groups.get(item.cropObjectKey).push(item);
  });
  return ordered.map((diagnoses) => {
    if (!diagnoses[0].cropObjectKey) return diagnoses[0];
    const score = (item) => item.category === "NORMAL" ? -1 : (item.conf ?? -1);
    const worst = diagnoses.reduce((a, b) => score(b) > score(a) ? b : a);
    const heatmap = diagnoses.find((item) => item.gradcam);
    return {
      ...worst,
      gradcam: heatmap?.gradcam || "",
      gradcamName: heatmap?.name || "",
      diagnoses,
    };
  });
}
